/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { BrandCollectionModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

type SubBrandsStateType = Readonly<{
    brands: any;
    isLoading: boolean;
}>;

const initialSubBrandsState: SubBrandsStateType = {
    brands: [],
    isLoading: false,
};

const reducer = {
    "Data/SubBrands/BeginLoadSubBrands": (draft: Draft<SubBrandsStateType>, action: { parameter: object }) => {
        draft.isLoading = true;
        draft.brands = undefined;
    },
    "Data/SubBrands/CompleteLoadSubBrands": (
        draft: Draft<SubBrandsStateType>,
        action: { parameter: object; collection: BrandCollectionModel },
    ) => {
        draft.isLoading = false;
        draft.brands = action.collection?.brands;
    },
};

const subBrands = createTypedReducerWithImmer(initialSubBrandsState, reducer);

(reducers as any).subBrands = subBrands;

export type SubBrandState = {
    subBrands: SubBrandsStateType;
} & ApplicationState;

type Reducers = {
    brands: typeof subBrands;
    isLoading: typeof subBrands;
};

export type SubBrandsActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
